import './riskMatrix.scss'

import { Box, Button, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from '../../../components/common/spinner/spinner'
import { useTranslation } from 'react-i18next'
import DatatableRiskMatrix from '../../../components/common/datatable/DatatableRiskMatrix'
import { useRiskMatrix } from '../../pages-hooks/useRiskMatrixs'
import { updateRiskMatrixFilters } from '../../../features/riskMatrix/riskMatrixSlice'
import { useNavigate } from 'react-router-dom'
import { FilterModal } from '../../../components/utilities/FilterModal'

const RiskMatrix = () => {
  const queryState = useSelector((state) => state.riskMatrix.filters)
  const [status, setStatus] = useState(queryState?.status)
  const [name, setName] = useState(queryState?.name)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(50)
  const [modalOpen, setModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation(['common'])

  useRiskMatrix(setIsLoading, isLoading)

  const handleResetButton = () => {
    if (status !== '') setStatus('')
    if (name !== '') setName('')
    setPage(0)
    setIsLoading(true)

    dispatch(
      updateRiskMatrixFilters({
        status: '',
        name: '',
        page: 0,
        viewMode: true,
        limit: 50,
        offset: 0,
      }),
    )
  }

  const handleDispatch = () => {
    setIsLoading(true)
    return dispatch(
      updateRiskMatrixFilters({
        status: status,
        name,
        page,
        viewMode: true,
        limit: rowsPerPage,
        offset: rowsPerPage * page,
      }),
    )
  }

  async function handleCreateRiskMatrix() {
    navigate('/admin/risk-matrix/creation')
  }

  useEffect(() => {
    handleDispatch()
  }, [rowsPerPage, page])

  return (
    <Box>
      <Box className={`${isLoading && 'spinner-transition'} filter`}>
        {isLoading && <Spinner noTransform />}

        <Box>
          <Box className="component-title">
            <Typography variant="h2">{t('common:riskMatrix')}</Typography>

            <Button
              size="small"
              variant="contained"
              onClick={() => {
                handleCreateRiskMatrix()
              }}
            >
              {`${t('common:create')} ${t('common:matrix')}`}
            </Button>
          </Box>
          <Typography variant="subtitle3">
            {/* Loren ipsum dolor sit amet Loren ipsum dolor sit amet Loren  */}
          </Typography>
        </Box>

        <Paper elevation={0}>
          <DatatableRiskMatrix
            setIsLoading={setIsLoading}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setModalOpen={setModalOpen}
            queryState={queryState}
          />
        </Paper>
      </Box>

      <FilterModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        handleResetButton={handleResetButton}
        setPage={setPage}
        handleDispatch={handleDispatch}
      >
        <Box className="modal-box-filters">
          <Box className="modal-box">
            <Typography variant="subtitle3">
              {t('common:by')} {t('common:name')}:
            </Typography>
            <TextField
              placeholder={t('common:searchByName')}
              required
              fullWidth
              value={name}
              onChange={(event) => setName(event.target.value)}
              size="small"
            />
          </Box>
        </Box>
      </FilterModal>
    </Box>
  )
}

export default RiskMatrix
